import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

const User_MainNav = ({ isOpen, toggleSidebar }) => {
  return (
    <>
      <div className={`main-nav lg:block ${isOpen ? 'block' : 'hidden'}`}>
        <div className="flex justify-between items-center p-4">
          <NavLink to="/">
            <img
              src="/assets/img/logo/glorious_1.webp"
              alt="Logo"
              className="w-[16rem]"
            />
          </NavLink>

          <button
            onClick={() => toggleSidebar(!isOpen)}
            className="lg:hidden p-2"
            aria-label="Toggle Menu"
          >
            <iconify-icon icon="solar:backspace-bold"></iconify-icon>
          </button>
        </div>

        {/* <button
          type="button"
          class="button-sm-hover"
          aria-label="Show Full Sidebar"
        >
          <iconify-icon
            icon="solar:double-alt-arrow-right-bold-duotone"
            class="button-sm-hover-icon"
          ></iconify-icon>
        </button> */}

        <div class="scrollbar" data-simplebar>
          <ul
            class="navbar-nav space-y-2 h-[82%] pb-8 overflow-y-scroll"
            id="navbar-nav"
          >
            <li class="menu-title">General</li>

            {[
              {
                path: '/user_dashboard/home',
                icon: 'solar:widget-5-bold-duotone',
                text: 'Dashboard',
              },
              {
                path: '/user_dashboard/product',
                icon: 'solar:t-shirt-bold-duotone',
                text: 'Products',
              },
              {
                path: '/user_dashboard/orders',
                icon: 'solar:bag-smile-bold-duotone',
                text: 'Orders',
              },
              {
                path: '/user_dashboard/cart',
                icon: 'solar:bag-smile-bold-duotone',
                text: 'Carts',
              },
              {
                path: '/user_dashboard/wish_list',
                icon: 'solar:bag-smile-bold-duotone',
                text: 'Wish List',
              },
              {
                path: '/user_dashboard/chat',
                icon: 'solar:chat-round-bold-duotone',
                text: 'Order Chat',
              },
              {
                path: '/user_dashboard/support_chat',
                icon: 'solar:chat-round-bold-duotone',
                text: 'Support Chat',
              },
            ].map(({ path, icon, text }) => (
              <li key={path} className="nav-item">
                <NavLink to={path} className="nav-link flex items-center gap-2">
                  <span className="nav-icon">
                    <iconify-icon icon={icon}></iconify-icon>
                  </span>
                  <span className="nav-text">{text}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default User_MainNav;
